module.exports = __webpack_public_path__ + "static/media/WhatwedoImg4.f34a8929.png";